export default __webpack_public_path__ + "static/media/platscalop.a7d0a40b.jpg";